import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * 仮登録用クラス
 */
@JsonObject('PreRegistParam')
export default class PreRegistParam {
  constructor() {
    this.email = undefined;
    this.emailConfirm = undefined;
    this.reCaptchaToken = undefined;
    this.examRankCode = null;
  }

  @JsonProperty('email')
  public email?: string;

  @JsonProperty('email_confirmation')
  public emailConfirm?: string;

  @JsonProperty('re_captcha_token')
  public reCaptchaToken?: string;

  @JsonProperty('exam_rank_code')
  public examRankCode: string|null;
}
